import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";



// import { CustomerInfoBlock, FarmsBlock, UsersBlock } from "./blocks";
import { CustomButton } from "../../components";
import ModalAccountRemove from "../accounts/modals/modal-account-remove";
import useaccount from "../../hooks/use-account";
import { LoginContext } from "../../context/login-context";
import useUsers from "../../hooks/use-users";
import useDealer from "../../hooks/use-dealer";
import { CustomerInfoBlock, FarmsBlock, UsersBlock } from "../account-details/blocks";
import DealerFarmsBlock from "./dealer-farms-block";
import DealerFarmModal from "./dealer-farm-modal";
import ModalUser from "../account-details/modals/modal-user";
import { Alert } from "@mui/material";
import RebatesClient from "../../RebatesClient";


const DealerDetails = (props) => {
  const navigate = useNavigate()
  // const { valleyUsers, valleyRefetchUsers } = useUsers()
  const { state: userData } = useContext(LoginContext);
  const { dealerName } = useParams();

  const { dealer, refetchDealer } = useDealer({ dealerName });


  const [showFarmModal, setShowFarmModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);

  const [activeUser, setActiveUser] = useState(null);

  const [editFarm, setEditFarm] = useState(null);

  useEffect(() => {
    refetchDealer()
  }, [dealerName])



  const handleRemoveAccount = async (id) => {

    await RebatesClient.removeDealer(dealer?.id)
    navigate('/dealers')
  };


  const handleAddEditFarm = (farm) => {
    console.log(farm)
    setEditFarm(farm);
    setShowFarmModal(true);
  };


  const handleHideFarmModal = (farm) => {
    refetchDealer()
    setEditFarm(null);
    setShowFarmModal(false);
  };


  // const handleRemoveFarm = (id) => {
  // 	setShowFarmRemoveModal(true);
  // };

  const handleAddEditUser = (user) => {
    console.log(dealer)
    setShowUserModal(true);
    setActiveUser(user);
  };
  const handleAddEditUserClose = () => {
    setShowUserModal(false);
    setActiveUser(null);
    refetchDealer()
  };


  const btnRemove = (
    <CustomButton
      label={`Remove Dealer`}
      onClick={handleRemoveAccount}
      color="danger"
      outlined
    />
  );

  const info = (
    <CustomerInfoBlock
      account={dealer}//{filteredAccounts[0] || null}
      // onClick={handleEditCompanyDetails}
      btnRemove={btnRemove}
    />
  );

  const tableFarms = (
    <DealerFarmsBlock
      farms={dealer?.farms}
      onAddFarm={handleAddEditFarm}
      // onRemoveFarm={handleRemoveFarm}
      onEditFarm={handleAddEditFarm}
    />
  );

  const tableUsers = (

    <UsersBlock
      canCrud={userData?.isValmontUser}
      users={dealer?.users}
      onAddEditUser={handleAddEditUser}
      userConfigType={"Dealer"}
    />
  );


  const modals = (
    <>

      {showFarmModal && (
        <DealerFarmModal
          open={showFarmModal}
          onClose={() => handleHideFarmModal()}
          dealer={dealer}
          farm_to_dealer={editFarm}
        />

      )}

      {showUserModal && (
        <ModalUser
          userConfigType={"Dealer"}
          open={showUserModal}
          onClose={handleAddEditUserClose}
          user={activeUser || { user_role: "DEALER" }}
          account={dealer}
        />
      )}

    </>
  )


  return (
    <>
      {info}
      {tableFarms}
      {tableUsers}
      {modals}
    </>
  );
};

export default DealerDetails;
